// Module
var code = "<div class=\"params-typeahead-result clearfix\" ng-click=\"context.onAdd($event, data)\"> <div class=\"clearfix row\"> <div class=\"col-xs-12\"> <div>{{ data.value }}</div> </div> </div> </div> ";
// Exports
module.exports = code;